import { Redirect } from 'expo-router';

import { Payment } from 'experiments/checkout-v2/control/pages/cart/payment/order-payment/payment';
import { useEnableCheckoutV2Experiment } from 'experiments/checkout-v2/use-enable-checkout-v2-experiment';
import { routes } from 'utils/routing';

export default function CartPaymentPage() {
  const isCheckoutV2 = useEnableCheckoutV2Experiment();

  if (isCheckoutV2) {
    return <Redirect href={routes.cartCheckout} />;
  }

  return <Payment />;
}
